import { CategoryImpact } from "../types/constraint";
import { Client, ConstraintEmployee } from "../types/ganttChart";

/**
 * Instant client-side estimate of a category's impact, shown while the authoritative backend
 * count (see ConstraintService.getCategoryImpact) is still in flight. Employees are scoped by
 * isCategoryConstraint because a category id and a citizen id are independent number sequences
 * and can collide, and employees hold both kinds of hensyn (see constraintDuplicates.ts).
 * Citizens don't need that check: the backend's ConstraintDto(ServiceClientRelationToCategory,
 * ...) constructor never sets isCategoryConstraint, so it arrives null on the wire — filtering
 * on it here would match nothing.
 */
export const getDerivedCategoryImpact = (
  categoryId: number,
  employees: ConstraintEmployee[],
  clients: Client[],
): CategoryImpact => ({
  employeeCount: employees.filter((employee) =>
    employee.constraints.some(
      (constraint) =>
        constraint.isCategoryConstraint && constraint.targetId === categoryId,
    ),
  ).length,
  citizenCount: clients.filter((client) =>
    (client.constraints ?? []).some(
      (constraint) => constraint.targetId === categoryId,
    ),
  ).length,
});
